// src/components/ui/CardWrapper.js
import React from "react";
import { useDrag, useDrop } from "react-dnd";

const type = "CARD";

const sizeClasses = {
  small: "min-h-[160px] text-sm",
  medium: "min-h-[240px]",
  large: "min-h-[300px]",
};

const shapeClasses = {
  square: "aspect-square",
  rectangle: "aspect-auto",
};

const CardWrapper = ({
  id,
  title,
  children,
  size = "medium",
  shape = "rectangle",
  isDraggable = false,
}) => {
  const [, dragRef] = useDrag({
    type,
    item: { id },
    canDrag: isDraggable,
  });

  const [, dropRef] = useDrop({
    accept: type,
    hover: (item) => {
      // Future enhancement for rearranging cards
    },
  });

  const cardClassNames = `
    bg-white rounded-2xl shadow-md p-6 flex flex-col transition-all
    hover:shadow-lg hover:-translate-y-1
    ${sizeClasses[size]} ${shapeClasses[shape]}
  `;

  return (
    <div ref={isDraggable ? (node) => dragRef(dropRef(node)) : null} className={cardClassNames}>
      {title && <div className="text-lg font-semibold mb-4">{title}</div>}
      <div className="flex-1">{children}</div>
    </div>
  );
};

export default CardWrapper;